export default __webpack_public_path__ + "static/media/img-id-frame.f33071ec.png";